import type { ReactNode } from "react";

/**
 * One icon + label + value row inside `SettingsReviewCard`. Mirrors the
 * prototype's `.review-setup-row` (Campaign-Builder-Master-Prototype.html,
 * CSS ~line 7290 onward).
 *
 * `leading-[1.6]` on the value is deliberate: the prototype sets no
 * line-height on `.review-setup-row-value`, so it inherits the body's 1.6,
 * while Tailwind's `text-sm` ships its own 1.25rem. Without the override the
 * value's line box is 20px instead of 22.4px and every row loses ~2.4px of
 * height. The 11px label uses an arbitrary size, which carries no bundled
 * line-height, so it already inherits 1.6 and needs no override.
 */
export interface SettingsReviewRowProps {
  icon: ReactNode;
  label: string;
  value: string;
}

export default function SettingsReviewRow({ icon, label, value }: SettingsReviewRowProps) {
  return (
    <div className="grid grid-cols-[28px_1fr_auto] items-center gap-3.5 border-b border-card-border py-3.5 last:border-b-0">
      <div className="flex items-center justify-center text-graphite">{icon}</div>
      <div className="font-lato text-[11px] font-bold uppercase tracking-[1.2px] text-graphite">
        {label}
      </div>
      <div className="max-w-[360px] text-right font-lato text-sm leading-[1.6] font-semibold text-rodeo-black">
        {value}
      </div>
    </div>
  );
}
